import { Component, OnInit } from '@angular/core';
import { FormArray, FormControl, FormGroup, Validators } from '@angular/forms';
import { Select, Store } from '@ngxs/store';
import { Observable } from 'rxjs';
import { RegistrationTestPatient } from 'src/app/core/models';
import {
  FetchRegistrationTestPatients,
  UpdateRegistrationTestPatient,
} from 'src/app/core/store/test-patients/test-patients.actions';
import { TestPatientsState } from 'src/app/core/store/test-patients/test-patients.state';
import { ApiStoreData } from 'src/app/core/store/utils';
import { asFormControl } from 'src/app/core/utils/common';
import { notCcsmedEmail, validateAllFormFields } from 'src/app/core/utils/validators';

@Component({
  selector: 'app-registration',
  templateUrl: './test-registration.component.html',
  styleUrls: ['./test-registration.component.scss'],
})
export class TestRegistrationComponent implements OnInit {
  @Select(TestPatientsState.registrationTestPatientsState) registrationTestPatientsState$!: Observable<
    ApiStoreData<(RegistrationTestPatient & UpdateRegistrationTestPatient)[]>
  >;

  emailsForm?: FormArray;

  asFormControl = asFormControl;

  constructor(private store: Store) {}

  ngOnInit() {
    this.store.dispatch(new FetchRegistrationTestPatients());
    this.registrationTestPatientsState$.subscribe((s) => {
      if (s.data.length) {
        this.emailsForm = new FormArray(
          s.data.map(
            (patient) =>
              new FormGroup({
                patientId: new FormControl(patient.patientId),
                email: new FormControl(null, [Validators.required, Validators.email, notCcsmedEmail()]),
              })
          )
        );
      }
    });
  }

  updateRegistrationTestPatient(patientId: number) {
    const formGroup = this.emailsForm?.controls.find((g) => g.value.patientId === patientId);
    if (formGroup) {
      if (!formGroup.valid) {
        validateAllFormFields(formGroup);
        return;
      }
      this.store.dispatch(new UpdateRegistrationTestPatient(patientId, formGroup.value.email));
    }
  }
}
